module.exports = __webpack_public_path__ + "img/login-img2.676bb26c.png";